<template>
  <div class="container">
    <div class="values-of-filter" v-for="filter in filters">
      <div class="main-values">
         <span class="value-filter"
               v-for="value in filter['children']"
               :data-id="value.id"
               v-on:click="infoParentClick($event, value.id)">
        {{ value.name }}
        </span>
      </div><!--.main-values-->
      <span class="value-filter"
            data-id="all"
            v-on:click="infoParentClick($event, 'all')">
        Ver tudo
      </span>
    </div><!--.values-of-filter-->

    <div class="project-articles">
      <div class="left-side">
        <div class="info-project-category">
          <h1 class="title-category">{{ category.class }}</h1>
          <p class="description-category">{{ category.description }}</p>
        </div><!--.info-project-category-->

        <div class="articles-list"
             v-if="articlesOdd.length"
             v-for="item in articlesOdd">
          <a :href="item.slug">
            <img class="img-article" v-if="item.featured_image"
                 :src="item.featured_image.mediaCollection['thumbnail_double_width']"
                 :alt="item.featured_image.title">
            <img class="img-article" v-else src="/img/frontend_assets/no-image.png"
                 :alt="category.title">
            <h1 class="title-article">{{ item.title }}</h1>

            <p class="excerpt-article" v-if="item.excerpt" v-html="item.excerpt"></p>
          </a>
        </div><!--.articles-list-->
      </div><!--.col-6-->
      <div class="right-side">
        <div class="articles-list"
             v-if="articlesEven.length"
             v-for="item in articlesEven">
          <a :href="item.slug">
            <img class="img-article" v-if="item.featured_image"
                 :src="item.featured_image.mediaCollection['thumbnail_double_width']"
                 :alt="item.featured_image.title">
            <img class="img-article" v-else src="/img/frontend_assets/no-image.png"
                 :alt="category.title">
            <h1 class="title-article">{{ item.title }}</h1>

            <p class="excerpt-article" v-if="item.excerpt" v-html="item.excerpt"></p>
          </a>
        </div><!--.articles-list-->
      </div><!--.col-6-->

    </div><!--.project-articles-->
  </div><!--.container-->
</template>

<script>
export default {
  props: {
    category: Object,
    filters: Object,
    articles: Object,
    articlesEven: Object,
    articlesOdd: Object
  },
  data: function () {
    return {

    }
  },
  methods: {
    infoParentClick(evt, id){
      this.$parent.handleClickedFilters(evt, id);
    }
  },
  mounted() {

  },
  created() {

  }
}
</script>
